import getCurrentSelectedTableView from '../utils/getSelectedTableView';

/**
 * Returns the number of mail items selected in the current table view.
 */
export default function getSelectedMailListItemsCount(): number {
    const tableView = getCurrentSelectedTableView();
    let selectedCount = 0;
    if (tableView) {
        if (tableView.isInVirtualSelectAllMode) {
            selectedCount =
                tableView.totalRowsInView - tableView.virutalSelectAllExclusionList.length;
        } else if (tableView.selectedItemsIds) {
            selectedCount = tableView.selectedItemsIds.size;
        }
    }
    return selectedCount;
}
